<template>
  <div class="container">
    <div class="title">
      Subscribe for Access to Premium Features
    </div>
    <div class="plans-container">
      <div class="plan-container shortened small">
        <div class="title basic">
          Basic
        </div>
        <div class="subtitle">
          Try it out!
        </div>
        <div class="body">
          <ul>Play with up to 5 players per game</ul>
          <ul>Access to basic prompts</ul>
        </div>
        <div class="price-container">
          Free
        </div>
      </div>
      <div class="plan-container shortened">
        <div class="title">
          Pro
        </div>
        <div class="subtitle">
          Step up your game
        </div>
        <div class="body">
          <ul>Play with up to 8 players per game</ul>
          <ul>Unlimited games</ul>
          <ul>Create and manage your own team</ul>
          <ul>Write your own prompts and add them to the game</ul>
          <ul>Premium prompt packs: onboarding, happy hour, team building, and icebreaker</ul>
          <ul>Save all scores</ul>
          <ul>Includes 8 seats</ul>
        </div>
        <div class="price-container">
          $24.99 / month
        </div>
        <div class="price-container small">
          Add more seats anytime for $2.99 / month
        </div>
      </div>
      <div class="plan-container shortened">
        <div class="title">
          Enterprise
        </div>
        <div class="subtitle">
          Fun for all
        </div>
        <div class="body">
          <ul>All Weavr Pro features</ul>
          <ul>Unlimited access for everyone at your company</ul>
          <ul>Three live events facilitated by our team each month</ul>
          <ul>We'll create one new prompt pack just for you each month</ul>
          <div class="tier-dropdown-container">
            <CustomSelect
              v-model="selectedEnterpriseTier"
              :options="enterpriseTierOptions"
            />
          </div>
        </div>
        <div class="price-container">
          ${{ this.enterpriseTierPrices[this.selectedTier - 1] }} / month
        </div>
      </div>
    </div>
    <div class="plan-suggestions-row">
      <div class="plan-suggestion-item small">
        <span>Best for taking Weavr for a test drive</span>
      </div>
      <div class="plan-suggestion-item">
        <span>Best for small teams who want to add their own company culture to the mix</span>
      </div>
      <div class="plan-suggestion-item">
        <span>Best for HR teams looking to use Weavr for engagement across their entire org</span>
      </div>
    </div>
    <div class="plan-suggestions-row">
      <div class="plan-suggestion-item small">
      </div>
      <div class="plan-suggestion-item">
        <div class="register-button-container">
          <SpinnerButton
            class="register-button"
            :showSpinner="false"
            @click="signup"
          >
            Sign up for free
          </SpinnerButton>
        </div>
      </div>
      <div class="plan-suggestion-item">
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import CustomSelect from '@/components/utilComponents/CustomSelect.vue';
import SpinnerButton from '@/components/utilComponents/SpinnerButton.vue';

export default Vue.extend({
  name: 'PricingView',
  components: {
    CustomSelect,
    SpinnerButton
  },
  data: () => ({
    selectedEnterpriseTier: null,
    enterpriseTierOptions: [
      '50-100 employees',
      '100-250 employees',
      '250-500 employees',
      '500+ employees'
    ],
    enterpriseTierPrices: [
      225,
      550,
      1000,
      1495
    ],
  }),
  computed: {
    finishedloading: function() {
      return !this.$auth.loading
    },
    isAuthenticated: function() {
      return !this.$auth.loading && this.$auth.isAuthenticated;
    },
    auth0UserId: function() {
      if (this.isAuthenticated) {
        return this.$auth.user.sub.replace(/\|/g, '_');
      }

      return '';
    },
    selectedTier: function() {
      return Math.max(this.enterpriseTierOptions.indexOf(this.selectedEnterpriseTier) + 1);
    },
  },
   methods: {
    signup() {
      this.$auth.loginWithRedirect({ appState: { targetUrl: '/pricing' }, screen_hint: 'signup' });
    },
  },
  created: async function() {
    this.selectedEnterpriseTier = this.enterpriseTierOptions[0];
  },
  mounted: function () {
    document.querySelector(".navbar.background").style.opacity = 1;
    document.querySelector(".logo img").style.filter = 'brightness(1) invert(0)'
    document.querySelector(".logo span").style.filter = 'brightness(1) invert(0)'
  }
})
</script>

<style scoped lang="scss">
@import '@/styles/pricing-screen.scss';
</style>
